import { MODE_CALCUL_FORFAIT, MODE_CALCUL_MANUEL } from '@/configuration/tiers/tiersConf';
import calculArrondi from '@/services/calcul/calculArrondi';
import * as produitConf from '@/configuration/catalogue/produitConf';

export function calculHonoraire(modeCalculHonoraire, montantHtLocation, montantHtTlpe) {
  if (modeCalculHonoraire.modeCalcul === MODE_CALCUL_MANUEL) return 0;

  if (modeCalculHonoraire.modeCalcul === MODE_CALCUL_FORFAIT) {
    return modeCalculHonoraire.montantForfaitHt ?? 0;
  }

  const pourcentage = modeCalculHonoraire.pourcentage ?? 0;
  const montantTlpe = montantHtTlpe ?? 0;
  const montantLocation = montantHtLocation ?? 0;

  if (modeCalculHonoraire.applicableSurLocation && !modeCalculHonoraire.applicableSurTlpe) {
    return calculArrondi(montantLocation * (pourcentage / 100), 2);
  }

  if (!modeCalculHonoraire.applicableSurLocation && modeCalculHonoraire.applicableSurTlpe) {
    return calculArrondi(montantTlpe * (pourcentage / 100), 2);
  }

  if (modeCalculHonoraire.applicableSurLocation && modeCalculHonoraire.applicableSurTlpe) {
    return calculArrondi((montantLocation + montantTlpe) * (pourcentage / 100), 2);
  }

  return 0;
}

export function getTotalAvecRemiseTlpe(ligneRegroupement) {
  const lignesEnfantTlpe = ligneRegroupement.lignesCommande
    .filter((ligneEnfant) => {
      return ligneEnfant.typeProduit === produitConf.CATEGORIE_DIVERS
        && ligneEnfant.produit && ligneEnfant.produit.produitDivers
        && ligneEnfant.produit.produitDivers.tlpe;
    });
  if (lignesEnfantTlpe.length === 0) return 0;
  return lignesEnfantTlpe
    .map((el) => { return el.totalHtAvecLigneRemise; })
    .reduce((a, b) => { return a + b; });
}

export function getTotalAvecRemiseLocation(ligneRegroupement) {
  const ligneEnfantLocation = ligneRegroupement.lignesCommande
    .filter((ligneEnfant) => {
      return ligneEnfant.typeProduit === produitConf.CATEGORIE_LOCATION;
    });
  if (ligneEnfantLocation.length === 0) return 0;
  return ligneEnfantLocation
    .map((el) => { return el.totalHtAvecLigneRemise; })
    .reduce((a, b) => { return a + b; });
}
